import { useSearchParams } from "react-router-dom";
import { ContainerCard } from "../../../../components/cards/containerCard";
import { InformationCard } from "../../../../components/cards/infoCard";
import { TabNav } from "../../../../components/navs/tabNav";
import { TitleSub } from "../../../../components/typography/titleSub";
import { ApprovalsSettings } from "./approvals";
import { RolesSettings } from "./roles";

type Views = "roles" | "approvals";

const navs: {
  title: string;
  to: Views;
}[] = [
  { title: "Roles", to: "roles" },
  { title: "Approvals", to: "approvals" },
];

export const RolesAndApprovals = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  return (
    <div className="flex flex-row flex-wrap width-lim:flex-nowrap w-full gap-2 md:gap-6">
      <ContainerCard className="w-full width-lim:max-w-[653px] width-lim:min-h-[685px] order-last width-lim:order-first flex flex-col gap-4">
        <TitleSub
          title="Roles & Approvals"
          subtitle="Manage the different roles of your cooperative officials. You can also configure approval chains here."
          titleClassName=""
          subtitleClassName=""
          className=""
        />

        <TabNav
          navs={navs.map((n) => ({
            title: n.title,
            to: n.to,
            onClick: () => {
              setSearchParams({
                ...Object.fromEntries(searchParams),
                view: n.to,
              });
            },
          }))}
          variant="switcher"
          activeTab={searchParams.get("view") ?? "roles"}
        />

        <div className="mt-2">
          {(searchParams.get("view") ?? "roles") === "roles" && (
            <RolesSettings />
          )}
          {(searchParams.get("view") ?? "roles") === "approvals" && (
            <ApprovalsSettings />
          )}
        </div>
      </ContainerCard>

      <InformationCard
        info={
          <p>
            <span className="text-pry-green-200 font-medium">
              Roles & Approvals{" "}
            </span>
            allow modularity in your cooperative operations. You can customise
            different roles and access rights.
          </p>
        }
        className="width-lim:!max-w-[345px] h-fit width-lim:sticky-top"
      />
    </div>
  );
};
